const HomeIcon = ({
  size = 36,
  onClick = (event) => {},
  className = ''
}: {
  size?: number;
  onClick?: (event) => void;
  className?: string;
}) => {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 32 32'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M25.5557 27.3332V12.9238L15.5557 5.19434L5.55566 12.9238L5.55566 27.3332L25.5557 27.3332ZM27.5557 12.9238V27.3332C27.5557 28.4378 26.6602 29.3332 25.5557 29.3332H5.55566C4.45109 29.3332 3.55566 28.4378 3.55566 27.3332V12.9238C3.55566 12.3045 3.84256 11.7201 4.33255 11.3414L14.3326 3.61193C15.0529 3.05514 16.0584 3.05514 16.7788 3.61193L26.7788 11.3414C27.2688 11.7201 27.5557 12.3045 27.5557 12.9238Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.4443 18.7778C11.4443 17.6733 12.3398 16.7778 13.4443 16.7778H17.6666C18.7711 16.7778 19.6666 17.6733 19.6666 18.7778V28.4445H17.6666L17.6666 18.7778H13.4443V28.4445H11.4443V18.7778Z'
        />
      </svg>
    </span>
  );
};

export default HomeIcon;
